// assets/custom-mega-menu.js
(function () {
  function getMegaData() {
    var el = document.getElementById('custom-mega-menu-data');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || el.innerText || '{}');
    } catch (e) {
      console.warn('Failed to parse mega menu JSON', e);
      return {};
    }
  }

function renderMegaMenu(config) {
  if (!config || !config.columns || !config.columns.length) return '';

  var cols = config.columns;

  var colsHtml = cols
    .map(function (col) {
      var hasLinks = Array.isArray(col.links) && col.links.length > 0;

      var linksHtml = (col.links || [])
        .map(function (link) {
          return (
            '<li><a class="custom-mega-menu__link" href="' +
            link.url +
            '">' +
            link.label +
            '</a></li>'
          );
        })
        .join('');

      // 2nd-level heading as a link if URL exists
      var colTitleInner = col.url
        ? '<a href="' +
          col.url +
          '" class="custom-mega-menu__column-title-link">' +
          col.title +
          '</a>'
        : col.title;

      var columnClass =
        'custom-mega-menu__column' +
        (hasLinks ? '' : ' custom-mega-menu__column--no-children');

      return (
        '<div class="' +
        columnClass +
        '">' +
        '<div class="custom-mega-menu__column-title">' +
        colTitleInner +
        '</div>' +
        '<ul class="custom-mega-menu__link-list">' +
        linksHtml +
        '</ul>' +
        '</div>'
      );
    })
    .join('');

  return '<div class="custom-mega-menu__inner">' + colsHtml + '</div>';
}



  function initCustomMegaMenu() {
    var megaData = getMegaData();
    var megaContainer = document.querySelector('[data-custom-mega-menu]');
    if (!megaContainer) return;

    var triggers = document.querySelectorAll(
      '.navmenu-item > details > summary[data-mega-key]'
    );

    var hideTimeout = null;

    function showForKey(key) {
      var config = megaData[key];
      if (!config || !config.columns || !config.columns.length) {
        megaContainer.classList.remove('custom-mega-menu--visible');
        megaContainer.setAttribute('aria-hidden', 'true');
        megaContainer.innerHTML = '';
        return;
      }

      megaContainer.innerHTML = renderMegaMenu(config);
      megaContainer.classList.toggle(
        'custom-mega-menu--cols-3',
        config.columns.length <= 3
      );
      megaContainer.classList.add('custom-mega-menu--visible');
      megaContainer.setAttribute('aria-hidden', 'false');
    }

    function scheduleHide() {
      hideTimeout = window.setTimeout(function () {
        megaContainer.classList.remove('custom-mega-menu--visible');
        megaContainer.setAttribute('aria-hidden', 'true');
        megaContainer.innerHTML = '';
      }, 150);
    }

    function cancelHide() {
      if (hideTimeout) {
        window.clearTimeout(hideTimeout);
        hideTimeout = null;
      }
    }

    triggers.forEach(function (trigger) {
      var key = trigger.getAttribute('data-mega-key');

      trigger.addEventListener('mouseenter', function () {
        cancelHide();
        showForKey(key);
      });

      trigger.addEventListener('focus', function () {
        cancelHide();
        showForKey(key);
      });

      trigger.parentElement.addEventListener('mouseleave', scheduleHide);
    });

    megaContainer.addEventListener('mouseenter', cancelHide);
    megaContainer.addEventListener('mouseleave', scheduleHide);

    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape') {
        megaContainer.classList.remove('custom-mega-menu--visible');
        megaContainer.setAttribute('aria-hidden', 'true');
        megaContainer.innerHTML = '';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomMegaMenu);
  } else {
    initCustomMegaMenu();
  }
})();
